import React, { useRef, useState, useEffect } from 'react';
import styles from '../laguspasterlaria/laguspasterlaria.module.scss';
import Perfil from './src/perfil.png';
import Link from '../../components/Link/link.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import catalogoPdf from './src/catalogo-laguspastelaria.pdf';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Laguspasterlaria: React.FC = () => {

    return (
        <div className={styles.laguspasterlaria}>
            <div className={styles["body-thunder"]}>
                <div style={{ height: "200px" }} className={styles["background-thunder"]}></div>
                <div className={`${styles["container-thunder"]}`} >
                    <img
                        className={styles["img-perfil"]}
                        src={Perfil}
                        alt="Profile Picture"
                    />
                    <h1>LAGUS PASTELARIA</h1>
                    <p>O melhor e mais crocante pastel de Barretos 😋</p>
                    <div className={styles.links}>
                        <Link
                            href="https://www.instagram.com/laguspastelaria?igsh=eGhsdWI0eW5zc2Jn"
                            title="Instagram"
                            icon={<InstagramIcon color="#f3912d" height="32" />}
                            backgroundColor="#402021"
                            backgroundColorHover="#523536"
                            colorText="#f3912d"
                        />
                        <Link
                            href="https://wa.me/5517981038773?text=Ol%C3%A1%2C%20gostaria%20de%20fazer%20um%20pedido."
                            title="Whatsapp"
                            icon={<WhatsappIcon color="#f3912d" height="40" />}
                            backgroundColor="#402021"
                            backgroundColorHover="#523536"
                            colorText="#f3912d"
                        />
                        <Link
                            href={catalogoPdf}
                            title="Catálogo"
                            icon={<CatalogIcon color="#f3912d" height="35" />}
                            backgroundColor="#402021"
                            backgroundColorHover="#523536"
                            colorText="#f3912d"
                        />
                        <Link
                            href="https://maps.app.goo.gl/8xkbbGdrMUoYpJSXA"
                            title="Localização"
                            icon={<MapsIcon color="#f3912d" height="40" />}
                            backgroundColor="#402021"
                            backgroundColorHover="#523536"
                            colorText="#f3912d"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Laguspasterlaria;
